import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import useScrollToId from 'hooks/useScrollToId'
import { useIntl } from 'react-intl'
import LuxPlusBenefitIcon from '../LuxPlusBenefitIcon'
import { getBenefitCtaConfig } from 'luxPlus/lib/utils'

interface Props {
  benefit: App.OfferSubscriptionBenefitItem
  noCta?: boolean
}

function LuxPlusLandingPageBenefit(props: Props) {
  const { benefit, noCta } = props
  const intl = useIntl()

  const ctaConfig = !noCta ? getBenefitCtaConfig(benefit.type) : undefined

  const {
    hasLoadedScrollElement,
    onScrollToId,
  } = useScrollToId(ctaConfig?.scrollTarget ?? '', -12)

  return <Group direction="vertical" gap={12} verticalAlign="space-between" key={benefit.title}>
    <VerticalSpacer gap={12}>
      <LuxPlusBenefitIcon benefit={benefit} colour="neutral-one" size="L" />
      <BodyText
        variant="medium"
        weight="bold"
        colour="neutral-one"
      >
        {benefit.title}
      </BodyText>
    </VerticalSpacer>
    {!!ctaConfig && <>
      {ctaConfig.scrollTarget && hasLoadedScrollElement && <TextLink size="small" onClick={onScrollToId}>{intl.formatMessage({
        id: '1X37zubOMmX_4CoBXCtG',
        defaultMessage: 'Browse offers',
        description: 'Link text to scroll to available offers for a LuxPlus benefit',
      })}
      </TextLink>}
      {ctaConfig.path && <TextLink size="small" to={ctaConfig.path}>{intl.formatMessage({
        id: 'd9yflecNfGrllnzkxLfA',
        defaultMessage: 'Learn more',
        description: 'Link text to navigate to more details about a LuxPlus benefit',
      })}
      </TextLink>}
    </>}
  </Group>
}

export default LuxPlusLandingPageBenefit
